import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  BodyTextMedium, HeadlineTextMedium, LozengeSmall,
} from 'Packages/FacetDesign/Components';
import { DueDateString } from 'Views/Page/Content/Modal/Layouts/MemberActionItem/Layout/DueDateString';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('name', {
    _component: () => HeadlineTextMedium,
  }, overrideReadOnly)
  .nameOverride(['description'], {
    _component: () => BodyTextMedium,
  }, overrideReadOnly)
  .nameOverride(['dueDateSummaryString'], {
    _component: () => DueDateString,
  }, overrideReadOnly)
  .nameOverride('pillar', {
    _component: () => LozengeSmall,
    _customProps: {
      color: 'primary',
    },
  }, overrideReadOnly);

export default metaOverrideSet;
